import moment from 'moment';

export const prepareChartData = (
  eventsByDay: {
    [key: string]: { [key: string]: { [key: string]: number } };
  },
  selectedRangeOption: string,
  mode: string,
) => {
  const endDate = moment().subtract(1, 'days');
  let startDate;
  switch (selectedRangeOption) {
    case 'week':
      startDate = moment().subtract(1, 'weeks');
      break;
    case 'month':
      startDate = moment().subtract(1, 'months');
      break;
    case '3 months':
      startDate = moment().subtract(3, 'months');
      break;
    default:
      startDate = moment().subtract(1, 'weeks');
  }

  const labels: string[] = [];
  const productViewData: number[] = [];
  const collectionViewData: number[] = [];
  const addToCartData: number[] = [];
  const returnVisitData: number[] = [];

  const eventType =
    mode === 'integrations' ? 'klaviyoShopify' : 'klaviyoManual';

  for (
    const date = startDate;
    date.isSameOrBefore(endDate);
    date.add(1, 'days')
  ) {
    const formattedDate = date.format('MMM DD');

    const keyDate = moment(date)
      .utc()
      .startOf('day')
      .toISOString()
      .replace(/[-:]/g, '')
      .replace(/\.\d{3}/, '')
      .replace('Z', '000Z');

    labels.push(formattedDate);

    productViewData.push(eventsByDay?.[eventType]?.productView?.[keyDate] || 0);
    collectionViewData.push(
      eventsByDay?.[eventType]?.collectionView?.[keyDate] || 0,
    );
    addToCartData.push(eventsByDay?.[eventType]?.addedToCart?.[keyDate] || 0);
    returnVisitData.push(eventsByDay?.[eventType]?.returnVisit?.[keyDate] || 0);
  }

  const allEventsData = labels.map(
    (value, index) =>
      productViewData[index] +
      collectionViewData[index] +
      addToCartData[index] +
      returnVisitData[index],
  );

  return {
    labels,
    datasets: [
      {
        label: 'All Events',
        data: allEventsData,
        borderColor: '#08979C',
        fill: false,
      },
      {
        label: 'Product View',
        data: productViewData,
        borderColor: '#08979C',
        fill: false,
      },
      {
        label: 'Collection View',
        data: collectionViewData,
        borderColor: '#2F54EB',
        fill: false,
      },
      {
        label: 'Add to Cart',
        data: addToCartData,
        borderColor: '#F5222D',
        fill: false,
      },
      {
        label: 'Return Visit',
        data: returnVisitData,
        borderColor: '#FAAD14',
        fill: false,
      },
    ],
  };
};
